import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from '../Icon'

const LoadingIcon = ({ classes, className }) => {
  return (
    <Icon
      data-element="loading-icon"
      name="reset"
      className={classNames(classes.icon, className)}
    />
  )
}

LoadingIcon.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    icon: PropTypes.string,
  }),
}

export default LoadingIcon
